import { flagOf, languageFlag } from '@cp/shared';

/**
 * A market as people say it: «DE» is Германия, «pt-BR» is бразильский
 * португальский. The browser knows the names; an unknown code stays a code.
 */
function named(type: 'region' | 'language', code: string): string | null {
  try {
    const name = new Intl.DisplayNames(['ru'], { type }).of(code);
    return name && name !== code ? name : null;
  } catch {
    return null;
  }
}

export function countryName(code: string): string | null {
  return /^[A-Z]{2}$/.test(code) ? named('region', code) : null;
}

export function languageName(tag: string): string | null {
  return /^[a-z]{2,3}(?:-[A-Za-z0-9]{2,8})*$/.test(tag) ? named('language', tag) : null;
}

/** «🇩🇪 Германия», for a line of plain text (a hint, an option): the flag font draws it there too (ADR-0060). */
export function countryWithFlag(code: string): string | null {
  const name = countryName(code);
  return name ? `${flagOf(code) ?? ''} ${name}`.trim() : null;
}

/** «🇰🇷 корейский», for a line of plain text. */
export function languageWithFlag(tag: string): string | null {
  const name = languageName(tag);
  return name ? `${languageFlag(tag) ?? ''} ${name}`.trim() : null;
}
